import type { StateTree } from '@makemydeal/dr-dash-types';
import { createLoggingContextSelector } from '../../selectors/loggingContextSelector';

/**
 * Creates a comprehensive logging context for socket events.
 * Includes deal, user, and application information shared across topic handlers.
 */
export const createSocketLoggingContext = (state: StateTree, event: any) => {
    return {
        ...createLoggingContextSelector(state),

        // Event details
        eventTopic: event.topic,
        eventMessage: event.message,
        eventData: event.data,
        eventTimestamp: event.data?.eventTime || new Date().toISOString(),
        connectionId: event.connectionId,

        // User context from event
        changedByPersona: event.data?.changedBy?.persona,
        changedByApplicationName: event.data?.changedBy?.applicationName,

        // Additional event-specific data
        newCreditAppId: event.data?.dealStructure?.creditApplication?.creditApplicationId,
        newOmsOrderNumber: event.data?.coxAutoReferences?.omsOrderNumber,
        eventName: event.data?.eventName || event.eventName,

        // Milestone context
        hasUpdatedMilestones: Boolean(event.updatedMilestones && Object.keys(event.updatedMilestones).length > 0),
        updatedMilestonesCount: event.updatedMilestones ? Object.keys(event.updatedMilestones).length : 0
    };
};
